

import React, { useState, useEffect,useMemo } from "react";
import axios from "axios";
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Stack,DialogActions,
  Pagination,
  Button,
} from "@mui/material";

import loadergif from "../../../assets/images/BG-switch loader_2.gif";

import Typography from "@mui/material/Typography";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import {  VAVE,GETIL4DATA,DOWNLOADUPLOADEDUSERFILE } from "../../../Pages/AppConstant";
import * as XLSX from "xlsx";




// const getStatusColor = (status) => {
//   switch (status) {
//     case "accepted":
//       return "green";
//     case "rejected":
//       return "red";
//     case "pending":
//       return "orange";
//     default:
//       return "gray";
//   }
// };

// const StatusDot = ({ status, name, onClick }) => (
//   <Tooltip title={`Status: ${status} (${name})`} arrow>
//     <span
//       onClick={onClick}
//       style={{
//         display: "inline-block",
//         width: "22px",
//         height: "22px",
//         borderRadius: "50%",
//         backgroundColor: getStatusColor(status),
//         margin: "auto",
//         cursor: "pointer",
//       }}
//     />
//   </Tooltip>
// );

// const IdeaTable = () => {
//   const [allIdeas, setAllIdeas] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [selectedApprover, setSelectedApprover] = useState(null);
//   const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
//   const [selectedIdea, setSelectedIdea] = useState(null);
//   const [isloading, setIsloading] = useState(false);

//   const itemsPerPage = 10;

//   const downloadUploadedUserDocApi = (request) => {
//     setIsloading(true);
//     axios({
//       method: "post",
//       url: VAVE + DOWNLOADUPLOADEDUSERFILE,
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       data: { idea_id: request.id_x },
//       responseType: "blob",
//     })
//       .then((response) => {
//         if (response.data.size === 14) {
//           alert("No Data Available");
//           setIsloading(false);
//           return;
//         }

//         const contentType =
//           response.headers["content-type"] || "application/pdf";
//         const disposition = response.headers["content-disposition"];
//         let filename = `Idea_${request.idea_unique_id}_User_Document.pdf`;

//         const blob = new Blob([response.data], { type: contentType });
//         const url = URL.createObjectURL(blob);

//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", filename);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);

//         // Clean up
//         URL.revokeObjectURL(url);
//         setIsloading(false);
//       })
//       .catch((error) => {
//         window.open(selectedIdea.filepath, "_blank");
//         setIsloading(false);
//       });
//   };

//   useEffect(() => {
//     fetchIdeas();
//   }, []);

//  const fetchIdeas = async () => {
//     const currentEmpId = localStorage.getItem("empid") || "";
//     // const url = allowedEmpIdsForIL2.includes(currentEmpId)
//     //   ? GETIL2BYEMPID
//     //   : GETIL2BYEMPID;

//     try {
//       const response = await axios.get(VAVE + GETIL4DATA, {
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//       });

//       const ideas = response.data.data || [];
//       setAllIdeas(ideas);
//       // if (!refreshApi) {
//       //   handleFilter("All", ideas); // Initial filter
//       // } else {
//       //   handleFilter("inprogress", ideas);
//       // }
//       // handleFilter("All", ideas); // Initial filter
//     } catch (error) {
//       console.error("Error fetching ideas:", error);
//     }
//   };

//   const ideaExcelDownloadSubmit = async () => {
//     try {
 
//       const dataToExport = filteredIdeas.length ? filteredIdeas : allIdeas;

//       const norm = (s) => (s || "").toString().trim().toLowerCase();
//       const pdApproved = dataToExport.filter(
//         (i) => norm(i.il1_pd_status) === "accepted"
//       ).length;
//       const pdPending = dataToExport.filter(
//         (i) => norm(i.il1_pd_status) === "pending"
//       ).length;
//       const sourcingApproved = dataToExport.filter(
//         (i) => norm(i.il1_sourcing_status) === "accepted"
//       ).length;
//       const sourcingPending = dataToExport.filter(
//         (i) => norm(i.il1_sourcing_status) === "pending"
//       ).length;

//       const summaryAOA = [
//         ["Status Summary"],
//         ["", "PD", "Sourcing"],
//         ["Approved", pdApproved, sourcingApproved],
//         ["Pending", pdPending, sourcingPending],
//       ];

//       const filteredData = dataToExport.map((item) => ({
//         id: `SWON-${item.id_x}`,
//         idea_category: item.idea_category,
//         partno: item.partno,
//         part_description: item.part_description,
//         il1_pd_status: item.il1_pd_status,
//         il1_sourcing_status: item.il1_sourcing_status,
//         il1_pd_comment: item.il1_pd_comment,
//         il1_sourcing_comment: item.il1_sourcing_comment,
//       }));

//       const workbook = XLSX.utils.book_new();

//       // Summary sheet
//       const summarySheet = XLSX.utils.aoa_to_sheet(summaryAOA);
//       XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

//       // Ideas sheet
//       const ideasSheet = XLSX.utils.json_to_sheet(filteredData);
//       XLSX.utils.book_append_sheet(workbook, ideasSheet, "Ideas");

//       XLSX.writeFile(workbook, "ideas_filtered.xlsx");
//     } catch (error) {
//       console.error("Error generating Excel:", error);
//     }
//   };


//   const updatedRequests = allIdeas.map((req) => {
//     const approvers = [];
//     if (req.il1_pd_approve) {
//       approvers.push({
//         name: req.il1_pd_approve,
//         status: req.il1_pd_status,
//         comment: req.il1_pd_comment,
//         role: "PD",
//       });
//     }
//     if (req.il1_sourcing_approve) {
//       approvers.push({
//         name: req.il1_sourcing_approve,
//         status: req.il1_sourcing_status,
//         comment: req.il1_sourcing_comment,
//         role: "Sourcing",
//       });
//     }
//     return { ...req, approvers };
//   });

 
//   const filteredIdeas = updatedRequests.filter((item) => {
//     const query = searchQuery.toLowerCase();
//     return Object.values(item).some((value) =>
//       String(value).toLowerCase().includes(query)
//     );
//   });


//   const totalPages = Math.ceil(filteredIdeas.length / itemsPerPage);
//   const paginatedIdeas = filteredIdeas.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );


//   const handleDotClick = (req, approver) => {
//     setSelectedRequest(req);
//     setSelectedApprover(approver);
//     setOpenDialog(true);
//   };

//   const handleViewMore = (idea) => {
//     setSelectedIdea(idea);
//     setViewMoreOpenDialog(true);
//   };

//   const handleViewMoreCloseDialog = () => {
//     setViewMoreOpenDialog(false);
//     setSelectedIdea(null);
//   };

//   const normalize = (s) => (s || "").toString().trim().toLowerCase();

//   const counts = React.useMemo(() => {
//     const list = filteredIdeas;
//     const pdApproved = list.filter(
//       (i) => normalize(i.il1_pd_status) === "accepted"
//     ).length;
//     const pdPending = list.filter(
//       (i) => normalize(i.il1_pd_status) === "inprogress"
//     ).length;
//     const pdRejected = list.filter(
//       (i) => normalize(i.il1_pd_status) === "rejected"
//     ).length;

//     const sourcingApproved = list.filter(
//       (i) => normalize(i.il1_sourcing_status) === "accepted"
//     ).length;
//     const sourcingPending = list.filter(
//       (i) => normalize(i.il1_sourcing_status) === "inprogress"
//     ).length;

//     const sourcingRejected = list.filter(
//       (i) => normalize(i.il1_sourcing_status) === "rejected"
//     ).length;

//     return { pdApproved, pdPending,pdRejected, sourcingApproved, sourcingPending, sourcingRejected };
//   }, [filteredIdeas, allIdeas]); 


//   return (
//     <div className="container mt-2">
//       {isloading ? (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0, 0, 0, 0.3)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <div className="loadergif">
//             <img src={loadergif} alt="Loading..." />
//           </div>
//         </div>
//       ) : (
//         ""
//       )}

//       <div className="row align-items-center pb-3 pt-2 g-3">
      
//         <div className="col-12 col-md-7 col-lg-7">
//           <div className="d-flex align-items-center gap-3 flex-wrap justify-content-md-start">
//             <div className="d-flex align-items-center">
//               <label className="me-2">Search</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Search..."
//                 value={searchQuery}
//                 onChange={(e) => {
//                   setSearchQuery(e.target.value);
//                   setCurrentPage(1);
//                 }}
//                 style={{ width: "200px" }}
//               />
//             </div>

//             <button
//               type="button"
//               className="btn btn-primary"
//               onClick={ideaExcelDownloadSubmit}
//             >
//               Download (Total Ideas: {allIdeas.length})
//             </button>
//           </div>
//         </div>


//          <div className="col-12 col-md-5 col-lg-4">
//           <div className="card shadow-sm">
//             <div className="card-header py-2">
//               <strong>Status Summary</strong>
//             </div>
//             <div className="card-body p-0">
//               <table className="table table-sm table-bordered mb-0 align-middle">
//                 <thead className="table-light">
//                   <tr>
//                     <th style={{ width: "40%" }}></th>
//                     <th className="text-center">PD</th>
//                     <th className="text-center">Sourcing</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>
//                       <span
//                         style={{
//                           display: "inline-block",
//                           width: 10,
//                           height: 10,
//                           borderRadius: "50%",
//                           backgroundColor: "green",
//                           marginRight: 8,
//                         }}
//                       />
//                       Approved
//                     </td>
//                     <td className="text-center">{counts.pdApproved}</td>
//                     <td className="text-center">{counts.sourcingApproved}</td>
//                   </tr>
//                       <tr>
//                     <td>
//                       <span
//                         style={{
//                           display: "inline-block",
//                           width: 10,
//                           height: 10,
//                           borderRadius: "50%",
//                           backgroundColor: "red",
//                           marginRight: 8,
//                         }}
//                       />
//                       Rejected
//                     </td>
//                     <td className="text-center">{counts.pdRejected}</td>
//                     <td className="text-center">{counts.sourcingRejected}</td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <span
//                         style={{
//                           display: "inline-block",
//                           width: 10,
//                           height: 10,
//                           borderRadius: "50%",
//                           backgroundColor: "orange",
//                           marginRight: 8,
//                         }}
//                       />
//                       Pending
//                     </td>
//                     <td className="text-center">{counts.pdPending}</td>
//                     <td className="text-center">{counts.sourcingPending}</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="table-responsive">
//         <table className="table table-bordered table-striped custom-table">
//           <thead className="thead-dark">
//             <tr>
//               <th>SW Id</th>
//               <th>Idea Category</th>
//               <th>PD Approved by</th>
//               <th>Sourcing Approved by</th>
//               <th>PD Status</th>
//               <th>Sourcing Status</th>
//               <th>View More</th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedIdeas.map((req, index) => (
//               <tr key={req.id_x}>
//                 <td>{req.idea_unique_id}</td>
//                 <td>{req.idea_category}</td>
//                 <td>{req.il1_pd_approve || "-"}</td>
//                 <td>{req.il1_sourcing_approve || "-"}</td>

//                 {/* PD Status */}
//                 <td>
//                   {req.approvers.find((a) => a.role === "PD") ? (
//                     <StatusDot
//                       status={req.approvers.find((a) => a.role === "PD").status}
//                       name="PD"
//                       onClick={() =>
//                         handleDotClick(
//                           req,
//                           req.approvers.find((a) => a.role === "PD")
//                         )
//                       }
//                     />
//                   ) : (
//                     "-"
//                   )}
//                 </td>

//                 <td>
//                   {req.approvers.find((a) => a.role === "Sourcing") ? (
//                     <StatusDot
//                       status={
//                         req.approvers.find((a) => a.role === "Sourcing").status
//                       }
//                       name="Sourcing"
//                       onClick={() =>
//                         handleDotClick(
//                           req,
//                           req.approvers.find((a) => a.role === "Sourcing")
//                         )
//                       }
//                     />
//                   ) : (
//                     "-"
//                   )}
//                 </td>

  
//                 <td
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handleViewMore(req)}
//                 >
//                   <FormatListBulletedIcon />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <Dialog
//         open={viewMoreOpenDialog}
//         onClose={handleViewMoreCloseDialog}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>Idea Details</DialogTitle>
//         <DialogContent>
//           {selectedIdea && (
//             <Grid container spacing={2}>
//               {/* Left Column */}
//               <Grid item xs={10} sm={6}>
//                 <Typography variant="body1">
//                   <strong>Sw.No:</strong> {selectedIdea.idea_unique_id}
//                 </Typography>
//                 {/* <Typography variant="body1">
//                   <strong>Status:</strong>{" "}
//                   <span style={{ color: getStatusColor(selectedIdea.status) }}>
//                     {selectedIdea.status}
//                   </span>
//                 </Typography> */}
//                 <Typography variant="body1">
//                   <strong>Idea Category:</strong> {selectedIdea.idea_category_x}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Part No:</strong> {selectedIdea.partno}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Description:</strong> {selectedIdea.part_description}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea_x}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Current Condition:</strong>{" "}
//                   {selectedIdea.current_condition}
//                 </Typography>
//                 {/* {sourcingEmpIds.includes(currentEmpId) ? ( */}
//                 <Typography variant="body1">
//                   <strong>Sourcing Comments:</strong>{" "}
//                   {selectedIdea.il1_sourcing_comment}
//                 </Typography>
//                 {/* ) : ( */}
//                 <Typography variant="body1">
//                   <strong>PD Comments:</strong> {selectedIdea.il1_pd_comment}
//                 </Typography>
//                 {/* )} */}
//               </Grid>
//               {/* Right Column */}
//               <Grid item xs={12} sm={6}>
//                 <Typography variant="body1">
//                   <strong>Savings:</strong> {selectedIdea.benefit}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Aggregate:</strong> {selectedIdea.idea_effective}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Model:</strong> {selectedIdea.model}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Variant:</strong> {selectedIdea.varient}
//                 </Typography>

//                 <Typography variant="body1">
//                   <strong>Sub Variant:</strong> {selectedIdea.subvarient}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Domain:</strong> {selectedIdea.domain}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Function:</strong> {selectedIdea.function}
//                 </Typography>
//                 <Typography variant="body1">
//                   <strong>Location:</strong> {selectedIdea.location}
//                 </Typography>

//                 <Typography variant="body1">
//                   <strong>Document:</strong>{" "}
//                   {selectedIdea.filepath ? (
//                     <button
//                       style={{
//                         cursor: "pointer",
//                         color: "blue",
//                         border: "transparent",
//                         background: "transparent",
//                       }}
//                       onClick={() => downloadUploadedUserDocApi(selectedIdea)}
//                     >
//                       Download File
//                     </button>
//                   ) : (
//                     "No File"
//                   )}
//                 </Typography>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleViewMoreCloseDialog} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Stack alignItems="center" marginTop={2}>
//         <Pagination
//           count={totalPages}
//           page={currentPage}
//           onChange={(event, value) => setCurrentPage(value)}
//           color="primary"
//           variant="outlined"
//           shape="rounded"
//         />
//       </Stack>
//     </div>
//   );
// };

// export default IdeaTable;






const isEmpty = (v) => v == null || String(v).trim() === "";

// Color mapping
const getStatusColor = (status) => {
  switch ((status || "").toLowerCase()) {
    case "accepted":
      return "green";
    case "rejected":
      return "red";
    case "pending":
    case "inprogress":
      return "orange";
    default:
      return "gray";
  }
};


const getPDOverallStatus = (r) => {
  if (String(r.pd_status).toLowerCase() === "rejected") return "rejected";


  return isEmpty(r?.approved_by_pd) || isEmpty(r?.drawing_no) || isEmpty(r?.ecn_edin)
    ? "pending"
    : "accepted";
};

const getQualityOverallStatus = (r) => {
  if (String(r.quality_status).toLowerCase() === "rejected") return "rejected";

  return (
    isEmpty(r?.approved_by_quality) ||
    isEmpty(r?.implementation_date) ||
    isEmpty(r?.vin_no)
  )
    ? "pending"
    : "accepted";
};



const StatusDot = ({ status, name, onClick }) => (
  <Tooltip title={`Status: ${status} (${name})`} arrow>
    <span
      onClick={onClick}
      style={{
        display: "inline-block",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        backgroundColor: getStatusColor(status),
        margin: "auto",
        cursor: "pointer",
      }}
    />
  </Tooltip>
);

const IdeaTable = () => {
  const [allIdeas, setAllIdeas] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedApprover, setSelectedApprover] = useState(null);

  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState(null);

  const [isloading, setIsloading] = useState(false);

  const itemsPerPage = 10;

  // ---------------------------
  // API: Fetch ideas
  // ---------------------------
  const fetchIdeas = async () => {
    try {
      const response = await axios.get(VAVE + GETIL4DATA, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response?.data?.data || [];
      setAllIdeas(ideas);
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);

  // ---------------------------
  // File download
  // ---------------------------
  const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request?.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response?.data?.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType = response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request?.idea_unique_id || request?.id_x}_User_Document.pdf`;

        // If server sent filename in headers
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) filename = decodeURIComponent(match[1]);
        }

        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch(() => {
        // Fallback: open stored file path if available
        const fallback = request?.filepath || selectedIdea?.filepath;
        if (fallback) window.open(fallback, "_blank");
        setIsloading(false);
      });
  };

  // ---------------------------
  // Enrich rows with computed PD/Quality approvers
  // ---------------------------
  const updatedRequests = useMemo(() => {
    return (allIdeas || []).map((req) => {
      const approvers = [
        {
          role: "PD",
          name: req?.approved_by_pd || "-",
          status: getPDOverallStatus(req), // accepted | pending | (rejected if you add later)
          comment: req?.il1_pd_comment || "",
        },
        {
          role: "Quality",
          name: req?.approved_by_quality || "-",
          status: getQualityOverallStatus(req),
          comment: req?.il1_sourcing_comment || "", // replace if you have dedicated quality comment
        },
      ];
      return { ...req, approvers };
    });
  }, [allIdeas]);


  const filteredIdeas = useMemo(() => {
    const q = (searchQuery || "").toLowerCase();
    if (!q) return updatedRequests;

    return updatedRequests.filter((item) =>
      Object.values(item).some((value) => String(value).toLowerCase().includes(q))
    );
  }, [searchQuery, updatedRequests]);

  const totalPages = Math.ceil((filteredIdeas?.length || 0) / itemsPerPage);
  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // ---------------------------
  // Status Summary Counts
  // ---------------------------
  const counts = useMemo(() => {
    const list = updatedRequests;
    const norm = (s) => (s || "").toString().trim().toLowerCase();

    const pdApproved = list.filter((i) => norm(getPDOverallStatus(i)) === "accepted").length;
    const pdPending = list.filter((i) => norm(getPDOverallStatus(i)) === "pending").length;
    const pdRejected = list.filter((i) => norm(getPDOverallStatus(i)) === "rejected").length;

    const qualityApproved =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "accepted").length;
    const qualityPending =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "pending").length;
    const qualityRejected =
      list.filter((i) => norm(getQualityOverallStatus(i)) === "rejected").length;

    return {
      pdApproved,
      pdPending,
      pdRejected,
      qualityApproved,
      qualityPending,
      qualityRejected,
    };
  }, [updatedRequests]);

  // ---------------------------
  // UI Handlers
  // ---------------------------
  const handleDotClick = (req, approver) => {
    setSelectedRequest(req);
    setSelectedApprover(approver);
    setOpenDialog(true);
  };

  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };

  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };

  // ---------------------------
  // Excel Export (uses computed PD/Quality)
  // ---------------------------
  const ideaExcelDownloadSubmit = async () => {
    try {
      const dataToExport = filteredIdeas.length ? filteredIdeas : updatedRequests;

      const filteredData = dataToExport.map((item) => ({
        id: `SWON-${item?.id_x}`,
        idea_category: item?.idea_category || item?.idea_category_x || "",
        partno: item?.partno || "",
        part_description: item?.part_description || "",
        benefit:item.benefit,
        idea_effective:item.idea_effective,
        model:item.model,
        varient:item.varient,
        subvarient:item.subvarient,
        pd_status: getPDOverallStatus(item),
        quality_status: getQualityOverallStatus(item),
        pd_approved_by: item?.approved_by_pd || "",
        quality_approved_by: item?.approved_by_quality || "",
        drawing_no: item?.drawing_no || "",
        ecn_edin: item?.ecn_edin || "", 
        vin_no: item?.vin_no || "", 
        
      }));

      // Summary sheet (computed counts)
      const summaryAOA = [
        ["Status Summary"],
        ["", "PD", "Quality"],
        ["Approved", counts.pdApproved, counts.qualityApproved],
        ["Pending", counts.pdPending, counts.qualityPending],
         ["Rejected", counts.pdRejected, counts.qualityRejected],
      ];

      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.aoa_to_sheet(summaryAOA);
      XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

      const ideasSheet = XLSX.utils.json_to_sheet(filteredData);
      XLSX.utils.book_append_sheet(workbook, ideasSheet, "Ideas");

      XLSX.writeFile(workbook, "ideas_filtered.xlsx");
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  return (
    <div className="container mt-2">
      {/* Loader overlay */}
      {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : null}

      {/* Top Bar */}
      <div className="row align-items-center pb-3 pt-2 g-3">
        <div className="col-12 col-md-7 col-lg-7">
          <div className="d-flex align-items-center gap-3 flex-wrap justify-content-md-start">
            <div className="d-flex align-items-center">
              <label className="me-2">Search</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ width: "200px" }}
              />
            </div>

            <button
              type="button"
              className="btn btn-primary"
              onClick={ideaExcelDownloadSubmit}
            >
              Download (Total Ideas: {allIdeas.length})
            </button>
          </div>
        </div>

        {/* Status Summary */}
        <div className="col-12 col-md-5 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-header py-2">
              <strong>Status Summary</strong>
            </div>
            <div className="card-body p-0">
              <table className="table table-sm table-bordered mb-0 align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "40%" }}></th>
                    <th className="text-center">PD</th>
                    <th className="text-center">Quality</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "green",
                          marginRight: 8,
                        }}
                      />
                      Approved
                    </td>
                    <td className="text-center">{counts.pdApproved}</td>
                    <td className="text-center">{counts.qualityApproved}</td>
                  </tr>

                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "red",
                          marginRight: 8,
                        }}
                      />
                      Rejected
                    </td>
                    <td className="text-center">{counts.pdRejected}</td>
                    <td className="text-center">{counts.qualityRejected}</td>
                  </tr>

                  <tr>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: "orange",
                          marginRight: 8,
                        }}
                      />
                      Pending
                    </td>
                    <td className="text-center">{counts.pdPending}</td>
                    <td className="text-center">{counts.qualityPending}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Main Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              <th>Idea Category</th>
              <th>PD Approved by</th>
              <th>Quality Approved by</th>
              <th>PD Status</th>
              <th>Quality Status</th>
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            {paginatedIdeas.map((req) => {
              const pdApprover = req.approvers.find((a) => a.role === "PD");
              const qualityApprover = req.approvers.find((a) => a.role === "Quality");

              return (
                <tr key={req.id_x}>
                  <td>{req.idea_unique_id || `SWON-${req.id_x}`}</td>
                  <td>{req.idea_category || req.idea_category_x || "-"}</td>
                  <td>{req.approved_by_pd || "-"}</td>
                  <td>{req.approved_by_quality || "-"}</td>

                  {/* PD Status */}
                  <td>
                    {pdApprover ? (
                      <StatusDot
                        status={pdApprover.status}
                        name="PD"
                        onClick={() => handleDotClick(req, pdApprover)}
                      />
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* Quality Status */}
                  <td>
                    {qualityApprover ? (
                      <StatusDot
                        status={qualityApprover.status}
                        name="Quality"
                        onClick={() => handleDotClick(req, qualityApprover)}
                      />
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* View more */}
                  <td style={{ cursor: "pointer" }} onClick={() => handleViewMore(req)}>
                    <FormatListBulletedIcon />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* View More Dialog */}
      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                  <strong>Employee Id:</strong> {selectedIdea.emp_id}
                </Typography>
                <Typography variant="body1">
                  <strong>Employee Email:</strong> {selectedIdea.emp_email}
                </Typography>
                <Typography variant="body1">
                  <strong>Sw.No:</strong> {selectedIdea.idea_unique_id || `SWON-${selectedIdea.id_x}`}
                </Typography>
                <Typography variant="body1">
                  <strong>Idea Category:</strong>{" "}
                  {selectedIdea.idea_category || selectedIdea.idea_category_x || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong>{" "}
                  {selectedIdea.proposed_idea || selectedIdea.proposed_idea_x || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Drawing No:</strong>{" "}
                  {selectedIdea.drawing_no || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>ECN EDIN:</strong> {selectedIdea.ecn_edin || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Vin No:</strong> {selectedIdea.vin_no || "-"}
                </Typography>
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function || "-"}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location || "-"}
                </Typography>

                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                    <button
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        border: "transparent",
                        background: "transparent",
                        textDecoration: "underline",
                        padding: 0,
                      }}
                      onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                    >
                      Download File
                    </button>
                  ) : (
                    "No File"
                  )}
                </Typography>

               
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Pagination */}
      <Stack alignItems="center" marginTop={2}>
        <Pagination
          count={totalPages || 1}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </Stack>
    </div>
  );
};

export default IdeaTable;
